import type { ReachKind } from '@/pages/discovered/types'

// Stable tab identities for the `view` URL param; the labels are display-only.
export const DETECTED_TAB = 'detected'
export const DISMISSED_TAB = 'dismissed'

// Fresh namespaces on purpose: the retired views system persisted a hidden status filter under
// the old 'discovery' key, which would silently empty the pre-split Detected tab if restored.
export const DISCOVERY_DETECTED_PREFIX = 'discovery-detected' as const
export const DISCOVERY_DISMISSED_PREFIX = 'discovery-dismissed' as const

// Tells a deep link from a notification apart from ordinary in-app navigation.
export const DISCOVERY_VIEW_EVENT_SOURCES = {
  NOTIFICATION: 'notification',
  NAV: 'nav',
} as const

// Devices first: the order both reach filter columns are declared in.
export const REACH_KINDS: readonly ReachKind[] = ['devices', 'users']
